if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        if (this.classList.contains('share-button--icons')) {
          this.urlToShare = this.dataset.shareUrl || document.location.href;
          this.shareTitle = this.dataset.shareTitle || document.title;
          this.shareImage = this.dataset.shareImage || '';
          return;
        }

        this.mainDetailsToggle = this.querySelector('details');
        if (!this.mainDetailsToggle) return;

        this.content = this.mainDetailsToggle.querySelector('summary')?.nextElementSibling;
        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
        this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.urlToShare, title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            ?.addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close')?.addEventListener('click', this.close.bind(this));
        }
      }

      static getShareHref(platform, url, title, image) {
        const encodedUrl = encodeURIComponent(url);
        const encodedTitle = encodeURIComponent(title || '');
        const encodedImage = encodeURIComponent(image || '');

        switch (platform) {
          case 'facebook':
            return `https://www.facebook.com/sharer.php?u=${encodedUrl}`;
          case 'twitter':
            return `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
          case 'pinterest':
            return `https://pinterest.com/pin/create/button/?url=${encodedUrl}&media=${encodedImage}&description=${encodedTitle}`;
          case 'email':
            return `mailto:?subject=${encodedTitle}&body=${encodedUrl}`;
          default:
            return url;
        }
      }

      onFocusOut() {
        setTimeout(() => {
          if (!this.contains(document.activeElement)) this.close();
        });
      }

      onToggle() {
        if (!this.content || !this.mainDetailsToggle) return;
        if (!this.animations) this.animations = this.content.getAnimations();

        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.animations.forEach((animation) => animation.play());
        } else {
          this.animations.forEach((animation) => animation.cancel());
        }
      }

      close() {
        if (!this.mainDetailsToggle) return;
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', false);
      }

      toggleDetails() {
        if (!this.mainDetailsToggle?.open) {
          this.elements.successMessage?.classList.add('hidden');
          if (this.elements.successMessage) this.elements.successMessage.textContent = '';
          this.elements.closeButton?.classList.add('hidden');
          this.elements.shareSummary?.focus();
        }
      }

      copyToClipboard() {
        navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        });
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.classList.contains('share-button--icons')) {
          this.dataset.shareUrl = url;
          this.querySelectorAll('a.share-button__link').forEach((link) => {
            const platform = link.dataset.sharePlatform;
            link.href = ShareButton.getShareHref(
              platform,
              url,
              this.shareTitle,
              this.shareImage
            );
          });
          return;
        }

        if (this.elements?.urlInput) this.elements.urlInput.value = url;
      }
    }
  );
}
